<div class="detail-recap" *ngIf="this.selectedSolution">

  <div class="detail-recap__header">
    <span *ngIf="loadingPriceCategoryStatus" class="spinner-border" role="status" aria-hidden="true"></span>
    <div *ngIf="!loadingPriceCategoryStatus">
      <!-- Prezzo ed ospiti -->
      <div class="detail-recap__occupancy">
        <!-- prezzo cabina selezionata (solo se è visualizzata la griglia solutions/prezzi) oppure prezzo best cabin della solution selezionata nel listato di ricerca -->
        <span *ngIf="selectedCabin && brand?.detailPageConfig.showPriceGrid" class="detail-recap__price">
          <span>da</span> &euro; {{selectedCabin.price | number:'1.0-0'}}
        </span>
        <span *ngIf="!selectedCabin" class="detail-recap__price">
          <span>da</span> &euro; {{(cruise$ | async)?.selectedSolution?.price | number:'1.0-0'}}
        </span>
        <span class="detail-recap__guests">
          <span *ngIf="(selectedCabin?.isUpdatedFromCategory || (cruise$ | async)?.selectedSolution?.isPriceUpdatedFromCategory) && occupancy?.guests">
            per {{occupancy.guests}} passeggeri
          </span>
          <span *ngIf="(selectedCabin?.isUpdatedFromCategory || (cruise$ | async)?.selectedSolution?.isPriceUpdatedFromCategory) && !occupancy?.guests">
            totale
          </span>
          <span *ngIf="!selectedCabin?.isUpdatedFromCategory && !(cruise$ | async)?.selectedSolution?.isPriceUpdatedFromCategory">
            per persona
          </span>
          <br>
          <span class="detail-recap__tax-info">(tasse e costi inclusi)</span>
        </span>
      </div>
      <!-- Modifica passeggeri (SOLO per WTG) -->
      <a *ngIf="brand?.networkId === networks.WTG"
         #editGuestsRef
         (click)="openEngineGuestsModal()"
         class="detail-recap__change-guests">
        Modifica passeggeri
      </a>
    </div>
  </div>

  <div class="detail-recap__body">
    <div class="detail-recap__row">
      <div class="detail-recap__icon">
        <i class="icon-clock-simple"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Durata</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">{{(cruise$ | async)?.selectedSolution?.days}} giorni</span>
      </div>
    </div>

    <div class="detail-recap__row">
      <div class="detail-recap__icon">
        <i class="icon-pin-shape"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Partenza da</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">{{(cruise$ | async)?.selectedSolution?.departureHarbour.name}}</span>
      </div>
    </div>

    <div class="detail-recap__row" *ngIf="(cruise$ | async)?.selectedSolution?.hasFlight">
      <div class="detail-recap__icon">
        <i class="icon-airplane"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Volo</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">Incluso</span>
      </div>
    </div>

    <div class="detail-recap__row">
      <div class="detail-recap__icon">
        <i class="icon-arrow-thick-right"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Imbarco</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">{{(cruise$ | async)?.selectedSolution?.departureDate | formatDate : 'extendedDateDayMonthYear'}}</span>
      </div>
    </div>

    <div class="detail-recap__row">
      <div class="detail-recap__icon">
        <i class="icon-arrow-thick-left"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Sbarco</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">{{(cruise$ | async)?.selectedSolution?.arrivalDate | formatDate : 'extendedDateDayMonthYear'}}</span>
      </div>
    </div>

    <!-- info cabina selezionata (solo se è visualizzata la griglia solutions/prezzi) -->
    <div *ngIf="selectedCabin?.description && brand?.detailPageConfig.showPriceGrid" class="detail-recap__row">
      <div class="detail-recap__icon">
        <i class="icon-double-bed"></i>
      </div>
      <div class="detail-recap__text">
        <strong>Cabina</strong>:
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">{{selectedCabin.description + ((selectedCabin.code) ? ' (' + selectedCabin.code + ')' : '')}}</span>
      </div>
    </div>

  </div>

  <!-- Pulsante Richiedi Informazioni -->
  <div class="detail-recap__accordion">
    <app-info-request [packetInfo]="(cruise$ | async)?.name" [packetUrl]="detailUrl | async" [isLanding]="isLanding"></app-info-request>
  </div>

  <!-- Pulsante Condividi -->
  <div class="detail-recap__share">
    <a target="_blank" class="detail-recap__share__button detail-recap__cta__button btn btn--blue-outline text-lowercase"
       href="https://www.facebook.com/sharer/sharer.php?u={{location}};src=sdkpreparse">
      <i class="icon-facebook detail-recap__share__icon"></i>
      <span class="detail-recap__share__text">Condividi</span>
    </a>
  </div>

  <!-- Call to Action -->
  <div class="detail-recap__footer">
    <div class="detail-recap__row detail-recap__cta__wrapper" *ngIf="!isLanding">
      <!-- disabilito la cta prosegui solo se la griglia solutions/prezzi è visualizzata ma non è stata ancora selezionata
      nessuna cabina (in tutti gli altri casi invece, la cta è abilitata) -->
      <a class="detail-recap__cta__button btn btn--brand-color-03"
         dynamicNavigation
         [ngClass]="{'disabled': (brand?.detailPageConfig.showPriceGrid && !selectedCabin) || loadingPriceCategoryStatus}"
         [href]="bookingUrl"
         >
        <span *ngIf="loadingPriceCategoryStatus" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!loadingPriceCategoryStatus">Prosegui</span>
      </a>
    </div>
    <span class="detail-recap__label" *ngIf="brand?.detailPageConfig.showPriceGrid && !selectedCabin && !loadingPriceCategoryStatus">Per poter proseguire è necessario selezionare una cabina/partenza.</span>
  </div>

</div>
